import React, { FC } from 'react';

import { Button, ButtonTypes } from '@eika/button';
import { InfoCard } from '@eika/card';
import { Modal } from '@eika/modal';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { meldSkadeNamespace } from '../../index';
import { Skademeldingstype } from '../../types/generated-types';
import { dataTrackIdPrefix } from '../../utils/piwik-utils';

import './inactive-modal.scss';

interface InactiveModalProps {
    skademeldingstype: Skademeldingstype | string;
    openModal: boolean;
    setOpen: () => void;
    setSessionUpdatedToNow: () => void;
    closeModal: () => void;
}

export const InactiveModal: FC<InactiveModalProps> = ({
    skademeldingstype,
    openModal,
    setOpen,
    setSessionUpdatedToNow,
    closeModal,
}) => {
    const onContinueClick = () => {
        setSessionUpdatedToNow();
        closeModal();
    };

    return (
        <Modal
            appNamespace={meldSkadeNamespace}
            id="inactive-modal"
            open={openModal}
            setOpen={setOpen}
            onClose={closeModal}
        >
            <InfoCard skipBackground>
                <RichIcon type={RichIconTypes.HAAND_HEIHEI} />
                <h1 className="light">Er du her fortsatt?</h1>
                <p>
                    Vi ser at du har vært inaktiv på denne siden en stund. Hvis du ikke fortsetter utfyllingen vil du
                    snart bli logget ut.
                </p>
            </InfoCard>
            <div className="inactive-modal-button">
                <Button
                    buttonType={ButtonTypes.STANDARD_POSITIVE}
                    onClick={onContinueClick}
                    data-track-id={`${dataTrackIdPrefix}-${skademeldingstype}-inactive-modal-button-continue`}
                >
                    Ja, fortsett utfylling
                </Button>
            </div>
        </Modal>
    );
};
export default InactiveModal;
